import React from "react";
import styled, { withTheme } from "styled-components";

const Container = styled.div`
  border-radius: 3px;
  background-color: ${(props) =>
    props.$backgroundColor ?? props.theme?.darkPurple};
  padding: 3px 8px;
  display: inline-block;
`;

const StyledText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme?.white};
`;

const CustomChip = (props) => {
  const { text, backgroundColor, onClick } = props;

  return (
    <Container
      data-testid={props["data-testid"] || "custom-chip"}
      $backgroundColor={backgroundColor}
      onClick={onClick}
    >
      <StyledText>{text}</StyledText>
    </Container>
  );
};

export default withTheme(CustomChip);
